export const PO_ADMINISTRADOR = ['PORTAL_ADMINISTRADOR'];

export const PO_REVCAD_CLIFOR_MENU     = ['PORTAL_ADMINISTRADOR' , 'PORTAL_ADMIN_FISCAL' , 'PO_REVCAD_CLIFOR_MENU' ];
export const PO_PRECAD_PRODUTO_MENU    = ['PORTAL_ADMINISTRADOR' , 'PO_PRECAD_PRODUTO_MENU' ];
export const PO_PRECAD_CLIENTE_MENU    = ['PORTAL_ADMINISTRADOR' , 'PO_PRECAD_CLIENTE_MENU' ];
export const PO_PRECAD_FORNECEDOR_MENU = ['PORTAL_ADMINISTRADOR' , 'PO_PRECAD_FORNECEDOR_MENU' ];
export const PORTAL_ADMIN_FISCAL       = ['PORTAL_ADMINISTRADOR' , 'PORTAL_ADMIN_FISCAL' ];
export const PO_REVCAD_PRODUTO_MENU    = ['PORTAL_ADMINISTRADOR' , 'PO_REVCAD_PRODUTO_MENU' ];
export const PO_AVALIA_CLIFOR_MENU     = ['PORTAL_ADMINISTRADOR' , 'PO_AVALIA_CLIFOR_MENU'];


export const PO_NETRIN_CONS_CLI_FOR     = ['PORTAL_ADMINISTRADOR' , 'PO_NETRIN_CONS_CLI_FOR'];
export const PO_NETRIN_ATUA_CLI_FOR     = ['PORTAL_ADMINISTRADOR' , 'PO_NETRIN_ATUA_CLI_FOR'];

export const PO_NETRIN_SUB_MENU = [...PO_NETRIN_CONS_CLI_FOR,...PO_NETRIN_ATUA_CLI_FOR]

export const PO_PROCESSOCADASTRO_MENU = [
  ...PO_PRECAD_PRODUTO_MENU,
  ...PO_REVCAD_CLIFOR_MENU,
  ...PO_AVALIA_CLIFOR_MENU,
  ...PO_NETRIN_SUB_MENU
];

export const PO_GUARITA           = ['PORTAL_ADMINISTRADOR', 'PO_GUARITA'];
export const PO_PEDVENDA          = ['PORTAL_ADMINISTRADOR', 'PO_PEDVENDA'];
export const PO_LIBPED          = ['PORTAL_ADMINISTRADOR', 'PO_LIBPED'];
export const PO_ESTOQUE           = ['PORTAL_ADMINISTRADOR', 'PO_ROMANEIO', 'PO_EXPEDICAO', 'PO_LISTAUR_MENU'];
export const PO_ROMANEIO          = ['PORTAL_ADMINISTRADOR', 'PO_ROMANEIO'];
export const PO_EXPEDICAO         = ['PORTAL_ADMINISTRADOR', 'PO_EXPEDICAO'];
export const PO_QUALIDADE         = ['PORTAL_ADMINISTRADOR', 'PO_QUALIDADE'];
export const PO_LISTAUR_MENU      = ['PORTAL_ADMINISTRADOR', 'PO_LISTAUR_MENU'];

export const PO_ESTOQUE_MENU = [
  ...PO_ROMANEIO,
  ...PO_EXPEDICAO,
  ...PO_QUALIDADE,
  ...PO_LISTAUR_MENU,
];

export const PO_PCP               = ['PORTAL_ADMINISTRADOR', 'PO_PCP'];
export const PO_PCP_ETIQ_MP_FORN1 = ['PORTAL_ADMINISTRADOR', 'PO_PCP_ETIQ_MP_FORN1'];

export const PO_PCP_MENU = [
  ...PO_PCP,
  ...PO_PCP_ETIQ_MP_FORN1,
];


export const PO_SC_MENU       = ['PORTAL_ADMINISTRADOR', 'PO_SC_MENU'];
export const PO_PC_MENU       = ['PORTAL_ADMINISTRADOR', 'PO_PC_MENU'];
export const PO_SC_APROVADOR  = ['PORTAL_ADMINISTRADOR', 'PO_SC_APROVADOR'];
export const PO_PC_PAINEL_APROVACAO = ['PORTAL_ADMINISTRADOR','PO_PC_PAINEL_APROVACAO']

export const PO_COMPRAS_MENU = [
  ...PO_SC_MENU,
  ...PO_PC_MENU,
  ...PO_SC_APROVADOR,
  ...PO_PC_PAINEL_APROVACAO,
];

export const PO_DDA_MENU       = ['PORTAL_ADMINISTRADOR', 'PO_DDA_MENU'];

export const PO_FINANCEIRO_MENU = [
  ...PO_DDA_MENU,
];
